import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    width: '100%',
    padding: 0,
    zoom: '50%',
    fontWeight: 300,
    // reduce by the height of the command bar as it's not on this page
    marginTop: `-${pxToRem(2 * layout.constants.commandBar.height)}`,
  },
  mobile: {
    marginTop: 0,
  },
  hero: {
    paddingTop: 100,
    paddingLeft: '10%',
    background: 'url("/images/hero-img.png") no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: 699,
  },
  heroHeader: {
    width: 972,
    height: 77,
    marginBottom: '2em',
    selectors: {
      '& span': {
        fontSize: 58,
        fontWeight: 300,
        letterSpacing: 0.1,
        lineHeight: 60,
        color: theme.palette.white,
      },
    },
  },
  heroDetails: {
    width: 704,
    height: 180,
    fontSize: '1.7rem',
    fontWeight: 300,
    textAlign: 'left',
    lineHeight: 35,
    color: theme.palette.white,
    marginBottom: '2em',
  },
  loginButton: {
    zoom: '200%',
  },
  aboutRoyalties: {
    fontSize: '1.4rem',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  aboutRoyaltiesHeadline: {
    margin: '1.3em 20% 1.3em 20%',
    lineHeight: '1.2em',
    textAlign: 'center',
    fontSize: '3rem',
  },
  card: {
    selectors: {
      [layout.breakpoints.min.md]: {
        width: '500px',
      },
      [layout.breakpoints.min.lg]: {
        width: '400px',
      },
      [layout.breakpoints.min.xxl]: {
        width: '15%',
      },
      [layout.breakpoints.min.xxxl]: {
        width: '35%',
      },
    },
    margin: '10px 5% 100px 5%',
  },
  cardItem: {
    padding: 5,
    textAlign: 'center',
    selectors: {
      '& .ms-Image': {
        padding: '0 0 50px 0',
      },
    },
  },
  cardHeading: {
    fontSize: '2rem',
    fontWeight: 100,
    lineHeight: '1.3em',
  },
  cardText: {
    fontSize: '1.6rem',
    fontWeight: 800,
    lineHeight: '1.3em',
  },
  contactButton: {
    zoom: '200%',
    maxWidth: '100% !important',
    selectors: {
      '& .ms-Button-label': {
        color: theme.palette.neutralLighter,
      },
    },
  },
  loginText: {
    color: `${theme.palette.neutralDark} !important`,
  },
  footer: {
    backgroundColor: theme.palette.neutralLight,
    padding: '50px 25px 50px 25px',
    marginTop: 50,
    selectors: {
      '& span': {
        fontSize: `${pxToRem(40)}`,
        fontWeight: 600,
        color: '#7d7e7d',
      },
      '& li': {
        padding: '10px 0',
        background: 'none',
        selectors: {
          a: {
            fontSize: `${pxToRem(26)}`,
            color: '#696565',
            transition: 'color 340ms ease-in-out',
            selectors: {
              '&:hover': {
                color: '#5a5454',
                textShadow: '.5px 0px 0px #c2bbbb',
              },
            },
          },
        },
      },
    },
  },
  navFooter: {
    backgroundColor: theme.palette.neutralLight,
    padding: '50px 25px 50px 25px',
    marginTop: 50,
    selectors: {
      '& a': {
        fontSize: `${pxToRem(22)}`,
        color: '#5a5454',
        transition: 'color 3400ms ease-in-out',
        selectors: {
          '&:hover': {
            color: '#5a5454',
            textShadow: '.5px 0px 0px #c2bbbb',
          },
        },
      },
      '& span': {
        fontSize: `${pxToRem(22)}`,
        color: '#5a5454',
        transition: 'color 3400ms ease-in-out',
        selectors: {
          '&:hover': {
            color: '#5a5454',
            textShadow: '.5px 0px 0px #c2bbbb',
          },
        },
      },
      alignSelf: 'center',
      padding: '20px 10px',
      borderColor: 'transparent',
      borderRadius: 0,
      color: 'white',
    },
  },
  buttonMargin: {
    marginBottom: '16px',
  },
});
